import React from 'react'
import { energyPerYearUnit, formatEnergy } from '../../../util/formatters'
import { SidebarTableRow } from '../../common/SidebarTableRow'

type Props = {
  title: string
  energyValue: number | null
  comparisonValue?: number | null
  isHeader?: boolean
}

export function SystemContainerSidebarTableRow({
  title,
  energyValue,
  comparisonValue,
  isHeader,
}: Props): React.ReactElement {
  const values = [energyValue]
  if (comparisonValue !== undefined) {
    values.push(comparisonValue)
  }

  const formatValue = (value: number | null) =>
    value === null
      ? '-'
      : formatEnergy(value, { omitUnit: true, increasePrecision: true })

  return (
    <SidebarTableRow
      title={
        isHeader ? `${title.toLocaleUpperCase()} (${energyPerYearUnit})` : title
      }
      values={values}
      formatValue={formatValue}
    />
  )
}
